import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppointmentsState } from '../../types/types.agendaCitas';

const initialState: AppointmentsState = {
  ModePatient: 'view',
  PatientData: null,
};

//Encargado de manejar todas las órdenes del sistema y configuración general

export const appointmentsSlice = createSlice({
  name: 'AppointmentsGlobal',
  initialState,
  reducers: {
    setPatient: (state, action: PayloadAction<any>) => {
      state.PatientData = action.payload;
    },
    clearPatient: (state) => {
      state.PatientData = { Pc_Identificacion: '' };
    },
  },
});

export const { setPatient, clearPatient, } = appointmentsSlice.actions;
